var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("SimpleTextPopup", {
    attrs: { title: _vm.title, hideRgtBtn: true, large: "" },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              { attrs: { fluid: "" } },
              [
                _c(
                  "v-layout",
                  { attrs: { "justify-space-between": "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs8: "", md2: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            label: _vm.$t("users"),
                            items: _vm.users,
                            "item-text": "name",
                            "item-value": "uid",
                            Box: ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "item",
                              fn: function(data) {
                                return [
                                  typeof data.item !== "object"
                                    ? [
                                        _c("v-list-tile-content", {
                                          domProps: {
                                            textContent: _vm._s(data.item)
                                          }
                                        })
                                      ]
                                    : [
                                        _c(
                                          "v-list-tile-content",
                                          [
                                            _c(
                                              "v-list-tile-title",
                                              [
                                                !data.item.uid
                                                  ? _c("v-icon", [
                                                      _vm._v(
                                                        "supervisor_account"
                                                      )
                                                    ])
                                                  : [
                                                      data.item.approvalType
                                                        ? _c("v-icon", [
                                                            _vm._v(
                                                              "perm_identity"
                                                            )
                                                          ])
                                                        : _c("v-icon", [
                                                            _vm._v(
                                                              "local_shipping"
                                                            )
                                                          ])
                                                    ],
                                                _vm._v(
                                                  "\n                    " +
                                                    _vm._s(data.item.name) +
                                                    "\n                  "
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        )
                                      ]
                                ]
                              }
                            }
                          ]),
                          model: {
                            value: _vm.selectedUser,
                            callback: function($$v) {
                              _vm.selectedUser = $$v
                            },
                            expression: "selectedUser"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs8: "", md2: "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            "append-icon": "filter_list",
                            label: _vm.$t("search"),
                            "single-line": "",
                            "hide-details": ""
                          },
                          model: {
                            value: _vm.filter,
                            callback: function($$v) {
                              _vm.filter = $$v
                            },
                            expression: "filter"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-data-table", {
                  staticClass: "levation-2 myDense",
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.distribution,
                    search: _vm.filter,
                    pagination: _vm.pagination,
                    "item-key": "fbmKey",
                    "rows-per-page-items": _vm.rowPerPage
                  },
                  on: {
                    "update:pagination": function($event) {
                      _vm.pagination = $event
                    }
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "items",
                      fn: function(props) {
                        return [
                          _c("td", { staticClass: "subheading" }, [
                            _vm._v(_vm._s(props.index + 1))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              _c("ProductWidget", {
                                attrs: {
                                  name: _vm.product.name,
                                  condition: _vm.product.condition,
                                  upc: _vm.product.upc,
                                  asin: _vm.product.asin,
                                  isCombined: _vm.product.isCombined,
                                  sku: props.item.sku
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.userName))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-left" },
                            [
                              _c("span", [_vm._v(_vm._s(props.item.siteName))]),
                              _vm._v(" "),
                              _vm.isHazmat &&
                              _vm.validHazmatSite(props.item.warehouseSite)
                                ? _c(
                                    "v-icon",
                                    {
                                      staticStyle: {
                                        color: "orange",
                                        "font-size": "16px"
                                      },
                                      attrs: {
                                        title: _vm.$t("supportDangerousGoods")
                                      }
                                    },
                                    [_vm._v("report_problem")]
                                  )
                                : _vm._e()
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("td", { staticClass: "text-xs-left" }, [
                            _vm._v(_vm._s(props.item.quantity))
                          ]),
                          _vm._v(" "),
                          _c(
                            "td",
                            { staticClass: "text-xs-right" },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    [
                                      _vm.addedDistributionSet.has(
                                        props.item.fbmKey
                                      )
                                        ? _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "success",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.deleteDistribution(
                                                    props.item
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.$t("added")))]
                                          )
                                        : _c(
                                            "v-btn",
                                            {
                                              attrs: {
                                                color: "primary",
                                                flat: ""
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.stopPropagation()
                                                  return _vm.addDistribution(
                                                    Object.assign(
                                                      {},
                                                      _vm.product,
                                                      props.item
                                                    )
                                                  )
                                                }
                                              }
                                            },
                                            [_vm._v(_vm._s(_vm.$t("add")))]
                                          )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08666676", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08666676","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InventoryDetails.vue
// module id = null
// module chunks = 